import { Injectable } from '@angular/core';

import { AtxLocationService } from '../../../other/locations/services';

@Injectable()
export class AtxNavService {
    constructor(private readonly atxLocationService: AtxLocationService) {}

    public getPrimaryPath() {
        const pathname = this.atxLocationService.getPathname();

        return pathname.split('/')[1];
    }
}
